'use client';

import LayoutHome from 'src/components/Layout/Home';
import data from './pe.json';
import howItWorksData from 'src/data/howItWorks.json';
import common from 'src/data/common.json';
import testimonialsData from 'src/data/testimonials.json';
import HeroBanner from 'src/components/Hero/HeroBanner';
import { track } from 'src/analytics/Analytics';
import EventNames from 'src/analytics/EventNames';
import Routes from 'src/constants/Routes';
import InfoGrid from 'src/components/InfoGrid/InfoGrid';
import DoctorFacts from 'src/components/DoctorFacts/DoctorFacts';
import Pricing from 'src/components/Pricing/Pricing';
import HowItWorks from 'src/components/HowItWorks/HowItWorks';
import Faq from 'src/components/Faq/Faq';
import OurDoctors from 'src/components/OurDoctors/OurDoctors';
import Testimonials from 'src/components/Testimonials/Testimonials';
import FreeConsult from 'src/components/FreeConsult/FreeConsult';
import { PageType } from 'src/analytics/EventProps';
import { useTrackPage } from 'src/analytics/Events';
import { Subvertical, Vertical } from 'src/constants/Verticals';
import Upsell from 'src/components/Upsell/Upsell';
import SeoContent from 'src/components/SeoContent/SeoContent';
import PeSeoContent from './PeSeoContent';
import { trackStartMyFreeConsultClick } from '../../analytics/Events';
import StickyButton, {
    handleStickyVisibility,
} from 'src/components/StickyButton/StickyButton';
import { Waypoint } from 'react-waypoint';
import classNames from 'classnames';
import styles from './pe.module.scss';
import { getSEOFaqMarkup } from 'src/helpers/seoUtils';

const structuredData = {
    faqs: getSEOFaqMarkup(common.faqs.sex.pe),
};

const PE = () => {
    useTrackPage('Premature Ejaculation', {
        vertical: Vertical.SEX,
        sub_vertical: Subvertical.PE,
        page_type: PageType.CATEGORY_PAGE,
    });

    return (
        <LayoutHome>
            <script
                key="structured-data"
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(structuredData),
                }}
            />
            <Waypoint onEnter={() => handleStickyVisibility('hide')} />
            <HeroBanner
                {...data.hero}
                vertical={Subvertical.PE}
                className={styles['hero']}
                cta={{
                    link: Routes.SEX_INITIAL_QUIZ,
                    label: common.takeTheQuiz,
                    trackEvent: () =>
                        track(EventNames.BUTTON_START_MY_FREE_CONSULT_CLICKED, {
                            vertical: Vertical.SEX,
                            subvertical: Subvertical.PE,
                            location: 'hero-cta',
                        }),
                }}
            />
            <section className="bg-green-light">
                <InfoGrid
                    items={[
                        {
                            image: {
                                src: '/images/icons/doc.png',
                                width: 72,
                                height: 72,
                            },
                            label: 'Aussie doctors',
                            backgroundColor: 'bg-green-light',
                            description:
                                "We work with leading doctors who'll help you understand your health needs",
                        },
                        {
                            image: {
                                src: '/images/icons/customers.png',
                                width: 130,
                                height: 120,
                            },
                            label: 'Trusted by over 150,000 Aussies',
                            backgroundColor: 'bg-green-light',
                            description:
                                "We've helped a heap of men to look great and regain their confidence. But who's counting.",
                        },
                        {
                            image: {
                                src: '/images/icons/medicine.png',
                                width: 72,
                                height: 72,
                            },
                            label: 'Modern, effective treatments',
                            backgroundColor: 'bg-green-light',
                            description:
                                'Our treatments are based on modern medications with evidenced-based effects.',
                        },
                    ]}
                />
            </section>
            <Waypoint
                onEnter={() => handleStickyVisibility('show')}
                bottomOffset="50%"
            >
                <section className="bg-sand-light py-8 md:py-16">
                    <DoctorFacts {...data.doctorFacts} />
                </section>
            </Waypoint>
            <section
                className={classNames(
                    styles['pricing'],
                    'bg-green-light py-8 md:py-16',
                )}
            >
                <Pricing
                    {...data.pricing}
                    cta={{
                        url: Routes.SEX_INITIAL_QUIZ,
                        label: common.takeTheQuiz,
                        trackEvent: () =>
                            track(
                                EventNames.BUTTON_START_MY_FREE_CONSULT_CLICKED,
                                {
                                    vertical: Vertical.SEX,
                                    subvertical: Subvertical.PE,
                                    location: 'pricing-cta',
                                },
                            ),
                    }}
                />
            </section>
            <section className="bg-sand-light py-8 md:py-16">
                <HowItWorks data={howItWorksData.default} />
            </section>
            <section className="bg-white py-8 md:py-16">
                <Faq list={common.faqs.sex.pe} />
            </section>
            <section className="bg-green-light py-8 md:py-16">
                <Upsell {...data.upsell} />
            </section>
            <section className="bg-sand-light py-8 md:py-16">
                <OurDoctors {...data.ourDoctors} />
            </section>
            <section className="bg-green-light py-8 md:py-16">
                <Testimonials list={testimonialsData.sex} />
            </section>
            <section className="bg-sand-light py-8 md:py-16">
                <FreeConsult
                    cta={{
                        text: common.getStarted,
                        location: 'page-bottom-cta',
                        href: Routes.SEX_INITIAL_QUIZ,
                    }}
                />
            </section>
            <SeoContent title="More about Premature Ejaculation">
                <PeSeoContent />
            </SeoContent>
            <StickyButton
                text={common.takeTheQuiz}
                link={Routes.SEX_INITIAL_QUIZ}
                onClick={() =>
                    trackStartMyFreeConsultClick({
                        vertical: Vertical.SEX,
                        subvertical: Subvertical.PE,
                        location: 'page-bottom-cta-mobile',
                        destination_url: Routes.SEX_INITIAL_QUIZ,
                    })
                }
            />
        </LayoutHome>
    );
};

export default PE;
